module.exports = __webpack_public_path__ + "img/logo16.88d5c097.jpg";